<div class="container-fuild" id="simplifySteps">
  <!-- <div class="row newHeader">
      <div class="col-12 pl-0"> -->
  <div class="row pt-1 d-flex align-items-center">
    <div class="col-md-8 step-title headPortion">
      <h5 class="mb-0">Individuals Information</h5>
      <p>Data fetched from the Individual's profile. To update navigate to individual's profile section</p>
    </div>
    <div class="col-md-4 editBtn headerSubPortion">
      <ul>
        <li class="firstPortion">
          <lib-step-status-update-component-library
            [visaType]="inputData.caseType === 'I130' ? inputData.caseType : inputData.visatype"
            [stepDetails]="stepDetails" type="EDIT">
          </lib-step-status-update-component-library>
        </li>
        <li class="secondPortion">
          <lib-maximize-dialog-library
            [configData]="{'layoutCode':stepDetails?.stepActionList[0].layoutCode}"></lib-maximize-dialog-library>
          <i (click)="handleClose();" class="close-icon pi pi-times"></i>
        </li>
      </ul>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 p-0">
      <lib-assigning-task-library [visaType]="inputData.visatype" [stepDetails]="stepDetails"
        (updateStatus)="updateStepStatus($event)" [isViewMode]="inputData['isViewMode']"
        [isCaseRequest]="inputData['isCaseRequest']">
      </lib-assigning-task-library>
    </div>
  </div>
  <lib-last-update-library [inputDetails]="stepDetails" [primaryData]="inputData" sectionCode="INDIVIDUAL_DETAIL">
  </lib-last-update-library>
  <!-- </div>
    </div> -->
  <div class="row">
    <div class="col-12 infoPortion">
      <p class="m-0">How to ON/OFF Skip Step?</p><mat-icon matTooltip="1. To skip any of the steps, use the slider. 
        2. Turning ON the slider (to the right, shows in blue) skips the step. 
        3. Turning OFF the slider (default left, shows in grey) retains the step in the petition.">info</mat-icon>
    </div>
  </div>
  <div class="main-body footer-adjust">
    <p-accordion *ngFor="let item of skipList" [ngSwitch]="item?.layOutCode">
      <p-accordionTab class="personalTab" (click)="onClickAccordion(0)" [selected]="activeTabIndex === 0"
        *ngSwitchCase="item?.layOutCode === 'PERSONAL_DETAILS' ? 'PERSONAL_DETAILS' : 'BEN_PERSONAL_DETAILS'">
        <ng-template pTemplate="header">
          <div class="stepHeader">
            <div class="headPortion">
              <h6 [ngClass]="item && item.disabled == true ? 'disableAccordion' : ''">Personal Details</h6><mat-icon
                *ngIf="item && item.disabled && item.child && item.child.length > 0"
                [matTooltip]="infoMsg">info</mat-icon>
            </div>
            <div class="skipPortion" [ngClass]="disabledControls == true ? 'disableAccordion' : ''">Skip Step
              <p-inputSwitch [(ngModel)]="item && item.disabled" class="pl-2"
                (onChange)="handleSwitchChange($event, item)">
              </p-inputSwitch>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="content">
          <lib-generic-beneficiary-personal-details-library (personalDetails)="personalDetails($event)"
            (profileEditStatus)="onEditClicked($event)" [detailsAbout]="selectedDetailAbout" (hasPassportChange)="onHasPassportChange($event)
      " [editMode]="personalDetailsEdit" [isShowProfilePic]="false" [passportShow]="true"
      [isShowVerify]="false"   [isEditDisabled]="disabledControls"></lib-generic-beneficiary-personal-details-library>

          <!-- <beneficiary-personal-details-library [ngClass]="item.disabled == true ? 'disableAccordion' : ''" [primaryData]="inputData" [simplifyH1b]="true" style="width:100%"></beneficiary-personal-details-library> -->
        </ng-template>
      </p-accordionTab>

      <p-accordionTab (click)="onClickAccordion(1)" [selected]="activeTabIndex === 1"
        *ngSwitchCase="item?.layOutCode === 'EDUCATION_DETAILS' ? 'EDUCATION_DETAILS' : 'BEN_EDUCATION_DETAILS'">
        <ng-template pTemplate="header">
          <div class="stepHeader">
            <div class="headPortion">
              <h6 [ngClass]="item && item.disabled == true ? 'disableAccordion' : ''">Education Details</h6><mat-icon
                *ngIf="item && item.disabled && item.child && item.child.length > 0"
                [matTooltip]="infoMsg">info</mat-icon>
            </div>
            <div class="skipPortion" [ngClass]="disabledControls == true ? 'disableAccordion' : ''">Skip Step
              <p-inputSwitch [(ngModel)]="item && item.disabled" class="pl-2"
                (onChange)="handleSwitchChange($event, item)">
              </p-inputSwitch>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="content">
          <education-details-library [ngClass]="item.disabled == true ? 'disableAccordion' : ''"
            [primaryData]="inputData" [simplifyH1b]="true" style="width:100%"></education-details-library>
        </ng-template>
      </p-accordionTab>

      <p-accordionTab (click)="onClickAccordion(2)" [selected]="activeTabIndex === 2"
        *ngSwitchCase="item?.layOutCode === 'EXPERIENCE_DETAILS' ? 'EXPERIENCE_DETAILS' : 'BEN_EXPERIENCE_DETAILS'">
        <ng-template pTemplate="header">
          <div class="stepHeader">
            <div class="headPortion">
              <h6 [ngClass]="item && item.disabled == true ? 'disableAccordion' : ''">Experience Details</h6><mat-icon
                *ngIf="item && item.disabled && item.child && item.child.length > 0"
                [matTooltip]="infoMsg">info</mat-icon>
            </div>
            <div class="skipPortion" [ngClass]="disabledControls == true ? 'disableAccordion' : ''">Skip Step
              <p-inputSwitch [(ngModel)]="item && item.disabled" class="pl-2"
                (onChange)="handleSwitchChange($event, item)">
              </p-inputSwitch>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="content">
          <work-experience-details-library [ngClass]="item.disabled == true ? 'disableAccordion' : ''"
            [primaryData]="inputData" [simplifyH1b]="true" style="width:100%">
          </work-experience-details-library>
        </ng-template>
      </p-accordionTab>

      <p-accordionTab (click)="onClickAccordion(3)" [selected]="activeTabIndex === 3"
        *ngSwitchCase="item?.layOutCode === 'IMMIGRATION_DOCUMENTS' ? 'IMMIGRATION_DOCUMENTS' : 'BEN_IMMIGRATION_DOCUMENTS'">
        <ng-template pTemplate="header">
          <div class="stepHeader">
            <div class="headPortion">
              <h6 [ngClass]="item && item.disabled == true ? 'disableAccordion' : ''">Immigration & Other documents</h6>
              <mat-icon *ngIf="item && item.disabled && item.child && item.child.length > 0"
                [matTooltip]="infoMsg">info</mat-icon>
            </div>
            <div class="skipPortion" [ngClass]="disabledControls == true ? 'disableAccordion' : ''">Skip Step
              <p-inputSwitch [(ngModel)]="item && item.disabled" class="pl-2"
                (onChange)="handleSwitchChange($event, item)">
              </p-inputSwitch>
            </div>
          </div>
        </ng-template>
        <ng-template pTemplate="content">
          <beneficiary-documents-library [ngClass]="item.disabled == true ? 'disableAccordion' : ''"
            [primaryData]="inputData" [simplifyH1b]="true" style="width:100%"></beneficiary-documents-library>
        </ng-template>
      </p-accordionTab>
    </p-accordion>
  </div>

  <div class="row">
      <div class="col-md-6 completeStep"></div>
      <div class="col-md-6 completeStep pt-3">
        <lib-step-status-update-component-library [isViewMode]="this.inputData['isViewMode']" [isCaseRequest]="this.inputData['isCaseRequest']"
          [visaType]="inputData.caseType != 'I130' ? inputData.visatype : inputData.caseType"
          [stepDetails]="stepDetails" [type]="typeOfButton" [showPreviousStepBtn]="showPrev" [showNextStepBtn]="showNext" class="d-flex col-12 justify-content-end"></lib-step-status-update-component-library>
      </div>
    </div>
</div>    
